import httpClient from "@/store/httpClient";
import { saveAs } from "file-saver";

export default {
    async loadKonzessionsThemen({ commit }) {
        const response = await httpClient.get("/users/me?type=konzessionsthemen");

        if(response.status === 200) {
            commit('SET_ITEMS', response.data);
        }
    },
    setSelectedThemaId({ commit }, themaId) {
        commit('SET_SELECTED_THEMA_ID', themaId);
    },
    setSortByKeyOrToggleOrder({ commit }, key) {
        commit('SET_SORT_BY_KEY_OR_TOGGLE_ORDER', key);
    },
    setSortBy({ commit }, sortBy) {
        commit('SET_SORT_BY', sortBy);
    },
    async loadKonzessionsabgaben({ commit, state }, { page = 1, pageSize = 25, append = false, filters = {} } = {}) {
        commit('SET_KONZESSIONSABGABEN_LOADING', true);

        const response = await httpClient.get("/enaio/testate", {
            params: {
                page,
                pageSize,
                ...filters,
            }
        });

        if(response.status === 200) {
            const responseData = response.data;
            const items = Array.isArray(responseData?.data) ? responseData.data : [];
            const total = typeof responseData?.total === 'number' ? responseData.total : undefined;
            const currentCount = append ? state.konzessionsabgaben.length + items.length : items.length;
            const hasMore = typeof total === 'number' ? currentCount < total : items.length === pageSize;

            if (append) {
                commit('APPEND_KONZESSIONSABGABEN', items);
            } else {
                commit('SET_KONZESSIONSABGABEN', items);
            }

            commit('SET_KONZESSIONSABGABEN_PAGINATION', { page, pageSize, hasMore });
        }

        commit('SET_KONZESSIONSABGABEN_LOADING', false);
    },
    async loadKonzessionsabgabenFilterValues({ commit }) {
        const response = await httpClient.get("/enaio/testate/filter-values");

        if(response.status === 200) {
            commit('SET_KONZESSIONSABGABEN_FILTER_VALUES', response.data);
        }
    },
    async downloadTestat(_, {id, filename }) {
        const response = await httpClient.get(`/enaio/download?id=${id}&type=testate`, { responseType: 'blob'});

        if(response.status === 200) {
            saveAs(response.data, filename);
        }
    },
    markAsRead({ commit }, osid) {
        commit('MARK_AS_READ', osid);
    }
}
